import { TabStyles } from '@tableau/widgets';

import { cssClass } from '../../style';

const cssPrefix = 'UploadContentProgressDialog';

export namespace UploadContentProgressDialogStyles {

  export const contentContainer = cssClass(cssPrefix, 'contentContainer', {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  });

  export const title = cssClass(cssPrefix, 'title', {
    fontSize: TabStyles.Typography.Sizing.XLarge
  });

  export const progressContainer = cssClass(cssPrefix, 'progress-container', {
    marginBottom: 12,
  });
}
